import React from 'react';
import { useAuth } from '../context/AuthContext';

const EnvironmentWrapper = ({ children, debugComponent, productionComponent }) => {
  const { user } = useAuth();
  
  // Check if debug widget should be enabled
  const isDebugEnabled = process.env.REACT_APP_ENABLE_DEBUG_WIDGET === 'true';
  const isAdminWithDebug = user?.roles?.includes('admin') && user?.debugEnabled;
  
  // Only show debug component if:
  // 1. Environment variable is set to true
  // 2. User is admin and has debug enabled
  const shouldUseDebugMode = isDebugEnabled && isAdminWithDebug;
  
  return (
    <>
      {children}
      {shouldUseDebugMode ? debugComponent : productionComponent}
    </>
  );
};

export default EnvironmentWrapper;